export default __webpack_public_path__ + "static/media/CDKGlobalWM_WHT.5c4e6910.jpg";